import script from "./DetailRequestPendingVerification.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailRequestPendingVerification.vue?vue&type=script&setup=true&lang=js"

import "./DetailRequestPendingVerification.vue?vue&type=style&index=0&id=1047a521&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1047a521"]])

export default __exports__